import { Checkbox, DataItemFormatter } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import styles from './CheckboxCellRenderer.module.scss';
import { OnEvent } from './CheckboxCellRenderer.types';

export interface CheckboxCellRendererProps {
  onChange?: OnEvent;
  onClick?: OnEvent;
  getIsChecked?: (item, index) => boolean;
  getIsIndeterminate?: (item) => boolean;
  isToggle?: boolean;
}

const cx = classNames.bind(styles);

/**
 * Will use value for its checked state unless it is not defined, then it will fall back
 * to getIsChecked callback from props to get its checked value.
 * Can be used as a toggle by passing isToggle property.
 */
const CheckboxCellRenderer: DataItemFormatter<boolean | undefined, ReactElement, CheckboxCellRendererProps> = ({
  props,
  value,
  item,
  row,
}) => {
  const { index } = row;
  const constructCheckboxEvent = (data) => ({
    checked: data.checked,
    indeterminate: data.indeterminate,
    index,
    item,
  });

  const onChange = (_, data) => {
    props?.onChange?.(constructCheckboxEvent(data));
  };

  const onClick = (_, data) => {
    props?.onClick?.(constructCheckboxEvent(data));
  };

  return (
    <div className={cx('body')}>
      <Checkbox
        className={cx({ toggle: props?.isToggle })}
        dataTestId={`cell-checkbox-${item?.id ?? ''}${index}`}
        onClick={onClick}
        onChange={onChange}
        checked={value ?? props?.getIsChecked?.(item, index)}
        indeterminate={props?.getIsIndeterminate?.(item)}
        toggle={props?.isToggle}
      />
    </div>
  );
};

export default CheckboxCellRenderer;
